import React from "react";
import { FullPageChat } from "@zeemee/react-web-chat";
import { useReactiveVar } from "@apollo/client";
import { Status, statusVar } from "@/reactiveVars/chat";
import { LoaderCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";
import { useParams } from "react-router-dom";
import { QualifiedChatIdSerializer } from "@/lib/QualifiedChatIdSerializer";

export const Chat = () => {
  const { t } = useTranslation();
  const { chat: chatParam } = useParams();
  const selectedChat = QualifiedChatIdSerializer.deserialize(chatParam);

  const { navToRoute } = useProtectedNavigation();

  const status = useReactiveVar(statusVar);

  return (
    <div className="absolute h-full w-full">
      {status === Status.BOOTSTRAP_IN_PROGRESS && (
        <div className="flex h-full items-center justify-center">
          <span className="sr-only">{t("global.loading")}</span>
          <LoaderCircle className="animate-spin" />
        </div>
      )}
      {status === Status.BOOTSTRAP_ERROR && (
        <div className="flex h-full items-center justify-center">
          {t("error.user")}
        </div>
      )}
      {status === Status.BOOTSTRAP_SUCCESS && (
        <FullPageChat
          selectedChat={selectedChat}
          onAutoSelectChat={(c) => {
            const chat = QualifiedChatIdSerializer.serialize(c);
            if (chat && chat !== chatParam) {
              navToRoute("selectedChat", { chat }, undefined, {
                replace: true,
              });
            } else if (chatParam) {
              navToRoute("chat");
            }
          }}
          onSelectedChatChange={(c) => {
            const chat = QualifiedChatIdSerializer.serialize(c);

            if (chat && chat !== chatParam) {
              navToRoute("selectedChat", { chat });
            } else if (chatParam) {
              navToRoute("chat");
            }
          }}
        />
      )}
    </div>
  );
};
